export default __webpack_public_path__ + "static/media/HERO.ad377e56.png";